const pop_up_style1 = "border-l-4 p-4 rounded-md my-4 bg-zinc-800"
const pop_up_style2 = "border-l-4 p-4 my-4 bg-zinc-900"

export default function PopUp({ color, icon, title, children, fontSize, notitle, ...props }) {
    const Icon = icon;

    return (
        <div className={pop_up_style1 + ` ${notitle ? "py-6" : ""}`} style={{ borderColor: color }}>
            {!notitle &&

                <div className='flex gap-2 items-center mb-2' style={{ color: color, fontSize: fontSize }} >
                    {
                        Icon ? <Icon size={24} /> : null
                    }
                    <strong style={{ color: color }}>{title}</strong>
                </div>
            }

            {children}
        </div>
    )
}